import { create } from 'zustand';

type ToastType = 'success' | 'error' | 'info' | 'systemError';

interface ToastState {
    message: string | null;
    type: ToastType;
    show: boolean;
    showToastAsync: (message: string, type?: ToastType, duration?: number) => Promise<void>;
    hideToast: () => void;
}

export const useToastStore = create<ToastState>((set) => ({
    message: null,
    type: 'success',
    show: false,
    showToastAsync: async (message, type = 'success', duration = 3000) => {
        set({ message, type, show: true });

        await new Promise<void>((resolve) => {
            setTimeout(() => {
                set({ show: false, message: null });
                resolve();
            }, duration);
        });
    },
    hideToast: () => set({ show: false, message: null }),
}));
